export interface ApiEndpoints {
  getDelivery: string;
  getSalesOrders: string;
  getSalesOrderDetails: string;
  getInvoices: string;
  getInvoice: string;
  getInvoicePdf: string;
  getDocumentUUIDByInvoiceUUID: string;
  getCustomerAccounts: string;
  getCustomerAccount: string;
  getCompanyOpenAmounts: string;
  getProductMaterial: string;
}

const endpoints: Record<string, ApiEndpoints> = {
  local: {
    getDelivery:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-delivery-khoutbounddelivery-local',
    getSalesOrders: 'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-sales-order-local',
    getSalesOrderDetails:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-sales-order-soap-local',
    getInvoices:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-invoices-khcustomerinvoice-local',
    getInvoice: 'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-invoice-soap-local',
    getInvoicePdf:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-invoice-pdf-soap-local',
    getDocumentUUIDByInvoiceUUID:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-document-uuid-by-invoice-uuid-outputrequest-soap-local',
    getCustomerAccounts:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-fetch-customer-account-khcustomer-local',
    getCustomerAccount:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-fetch-account-odata-local',
    getCompanyOpenAmounts:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-fetch-open-amounts-soap-local',
    getProductMaterial:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-material-local',
  },
  development: {
    getDelivery:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-delivery-khoutbounddelivery',
    getSalesOrders: 'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-sales-order-test',
    getSalesOrderDetails: 'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-sales-order',
    getInvoices:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-invoices-khcustomerinvoice',
    getInvoice: 'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-invoice-soap',
    getInvoicePdf: 'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-invoice-pdf-soap',
    getDocumentUUIDByInvoiceUUID:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-document-uuid-by-invoice-uuid-outputrequest-soap',
    getCustomerAccounts:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-fetch-customer-account-khcustomer',
    getCustomerAccount:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-fetch-account-odata',
    getCompanyOpenAmounts:
      'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-fetch-open-amounts-soap',
    getProductMaterial: 'https://uat-igt.alumio.com/api/v1/http-proxy/http-proxy-get-material',
  },
  production: {
    getDelivery: 'https://igt.alumio.com/api/v1/http-proxy/sap-odata-get-outbound-deliveries',
    getSalesOrders: 'https://igt.alumio.com/api/v1/http-proxy/sap-odata-get-sales-order',
    getSalesOrderDetails: 'https://igt.alumio.com/api/v1/http-proxy/sap-soap-get-sales-order',
    getInvoices: 'https://igt.alumio.com/api/v1/http-proxy/sap-odata-get-invoices',
    getInvoice: 'https://igt.alumio.com/api/v1/http-proxy/sap-soap-get-invoice-by-id',
    getInvoicePdf: 'https://igt.alumio.com/api/v1/http-proxy/sap-soap-get-invoice-pdf-by-id',
    getDocumentUUIDByInvoiceUUID:
      'https://igt.alumio.com/api/v1/http-proxy/sap-soap-get-document-uuid-by-invoice-uuid',
    getCustomerAccounts: 'https://igt.alumio.com/api/v1/http-proxy/sap-odata-get-customer-account',
    getCustomerAccount: 'https://igt.alumio.com/api/v1/http-proxy/sap-soap-get-account',
    getCompanyOpenAmounts: 'https://igt.alumio.com/api/v1/http-proxy/sap-soap-get-open-amounts',
    getProductMaterial: 'https://igt.alumio.com/api/v1/http-proxy/sap-soap-get-material',
  },
};

const currentEnv = import.meta.env.VITE_APP_API_ENV || 'production';

export const API_ENDPOINTS: ApiEndpoints = endpoints[currentEnv];
